///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class DialogAction {
    public static readonly CREATE = 'create';
    public static readonly EDIT = 'edit';
    public static readonly DELETE = 'delete';
    public static readonly BLOCK = 'block';
}
